import type { ComponentProps } from "react";
import React from "react";

type ContainerProps = ComponentProps<"div">;

export const Container = (props: ContainerProps) => <div {...props} />;
